<template>
  <v-container
    fluid
    fill-height
    class="xs-only-px-0 pa-2"
  >
    <v-layout>
      <v-flex xs12>
        <v-card
          height="100%"
          class="d-flex column"
        >
          <v-card-title class="headline">
            Admin
          </v-card-title>
          <div class="d-flex flex-row flex-wrap fill-height">
            <v-card
              v-for="category in items"
              :key="category.title"
              height="100%"
            >
              <v-card-title class="subtitle-1">
                {{ category.title }}
              </v-card-title>
              <v-card-text>
                <v-btn
                  v-for="item in category.items"
                  :key="item.title"
                  :to="item.to"
                  text
                  color="primary"
                >
                  {{ item.title }}
                </v-btn>
              </v-card-text>
            </v-card>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  name: 'OLAdmin',
  data: () => ({
    items: [{
      title: 'Document Templates',
      icon: ['fal', 'file'],
      items: [
        {
          title: 'Manage Templates',
          to: '/oladmin/templates'
        }
      ]
    }]
  }),
  computed: {
    itemsSorted() {
      return this.items.slice(0).map(item => {
        return {
          ...item,
          items: item.items.slice(0).sort((a, b) => a.title.localCompare(b.title))
        }
      })
    }
  }
}

</script>
